import Model, { attr, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type DashboardReport from './dashboard-report';

interface LayoutSection {
  label: string;
  type: 'stat_row' | 'chart_grid' | string;
}

interface LayoutConfig {
  columns?: number;
  gap?: 'sm' | 'md' | 'lg';
  sections?: LayoutSection[];
}

export default class Dashboard extends Model {
  @attr declare name: string;
  @attr declare description: string;
  @attr declare layoutConfig: LayoutConfig;
  @attr declare visibilityLevel: string;
  @attr declare partnerAccessConfig: number[];
  @attr declare isDefault: boolean;
  @attr declare isTemplate: boolean;
  @attr declare templateKey: string;
  @attr declare createdBy: number;
  @attr declare updatedBy: number;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @hasMany('dashboard-report', { async: false, inverse: 'dashboard' })
  declare dashboardReports: DashboardReport[];

  get isGlobal() {
    return this.visibilityLevel === 'global';
  }

  get isPartnerShared() {
    return this.visibilityLevel === 'partner';
  }

  get isPrivate() {
    return this.visibilityLevel === 'private';
  }

  get reportCount() {
    return this.dashboardReports?.length ?? 0;
  }

  get orderedReports() {
    return [...(this.dashboardReports ?? [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  }

  get visibilityLabel() {
    switch (this.visibilityLevel) {
      case 'private':
        return 'Private';
      case 'partner':
        return 'Partner Shared';
      case 'global':
        return 'Global';
      default:
        return 'Unknown';
    }
  }

  [Type] = 'dashboard' as const;
}

export type { LayoutConfig, LayoutSection };
